// extracted by mini-css-extract-plugin
module.exports = {"leftContainer":"_slug__leftContainer__iES06","fixedPanel":"_slug__fixedPanel__26KCv"};